import Chat from '../Chat/Chat.jsx';
import NavBar from  '../NavBar/NavBar.jsx';
import Sidebar from '../NavBar/Sidebar.jsx';
import './MainFrame.css';

import Home from './Home/Home.jsx';
import Calendario from './Calendario/Calendario.jsx';
import Cursada from './Cursada/Cursada.jsx';
import Cursadaslist from './Cursada/CursadasList.jsx';
import Administracion from './Administracion/Administracion.jsx';
import Buzon from './Buzon/Buzon.jsx';
import Ayuda from './Ayuda/Ayuda.jsx';
import Profile from './Profile/Profile.jsx';
import Contact from './Ayuda/Contact.jsx';
import Faqs from './Ayuda/Faqs.jsx';
import Historial from './Ayuda/Historial.jsx';
import { useState } from 'react';
import Notifications from './Notifications/Notifications.jsx';
import Contactos from './Contactos/Contactos.jsx';

const MainFrame = (props) => {

    const [actualCourseId, setActualCourseId] = useState(0);

    var $nav = document.getElementById('nav-cont');
    var $brg = document.getElementById('burger')

    if($nav != null){
        if(window.scrollY > 20 || props.actualFrame === 'cursada'){
            $nav.style.opacity = 0;
            $nav.style.zIndex = -1;
        }else{
            $nav.style.opacity = 1;
            $nav.style.zIndex = 5;
        }
    }

    setTimeout(() => {
        if($brg != null){
            if(window.scrollY > 20 || props.actualFrame === 'cursada'){
                $brg.style.filter = 'brightness(.9)';
            }else{
                $brg.style.filter = 'brightness(1)';
            }
        }
    }, 200);
    

    var frame;
    switch(props.actualFrame){
        case 'calendar':{
            frame = <Calendario />
            break;
        };
        case 'cursadas': {
            frame = <Cursadaslist setActualFrame={props.setActualFrame} setSidebarState={props.setSidebarState} setActualCourseId={setActualCourseId}/>
            break;
        };
        case 'cursada': {
            frame = <Cursada setActualFrame={props.setActualFrame} setSidebarState={props.setSidebarState} idCursada={actualCourseId}/>
            break;
        }
        case 'administracion': {
            frame = <Administracion />
            break;
        };
        case 'buzon': {
            frame = <Buzon setSidebarState={props.setSidebarState} usrData={props.usrData}/>
            break;
        };
        case 'ayuda': {
            frame = <Ayuda setActualFrame={props.setActualFrame}/>
            break;
        };
        case 'contact': {
            frame = <Contact  setActualFrame={props.setActualFrame}/>
            break;
        };
        case 'historial': {
            frame = <Historial  setActualFrame={props.setActualFrame}/>
            break;
        };
        case 'faqs': {
            frame = <Faqs  setActualFrame={props.setActualFrame}/>
            break;
        };
        case 'profile':{
            frame = <Profile usrData={props.usrData}/>
            break;
        }
        case "notificaciones":{
            frame = <Notifications usrData={props.usrData} setActualFrame={props.setActualFrame}/>;
            break;
        };
        case 'contactos': {
            frame = <Contactos />
            break;
        }
        default:{
            frame = <Home usrData={props.usrData} setActualFrame={props.setActualFrame}/>;
            break;
        };
    }




    const sidebarClass = props.sidebarState === 0 ? 'content-sidebar-expanded'
                        : props.sidebarState === 1 ? 'content-sidebar-collapsed'
                        : 'content-sidebar-hidden';

    return (
        <>
            <NavBar usrData={props.usrData} setActualFrame={props.setActualFrame} actualFrame={props.actualFrame}/>
            <Sidebar setActualFrame={props.setActualFrame} actualFrame={props.actualFrame} sidebarState={props.sidebarState} setSidebarState={props.setSidebarState} changeSidebarState={props.changeSidebarState}/>
            <Chat />
            <div className={sidebarClass}>
                {frame}
            </div>
        </>
    );
}

export default MainFrame;